import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Input } from "@/components/inputs/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { SirenIcon } from "lucide-react";
import { TakeRateExceptionFieldsProps } from "./take-rate-exception-fields.types";

/**
 * Campos obrigatórios quando o take rate lançado é uma exceção comercial
 * (abaixo de 10%). Os nomes dos campos vêm do adapter take-rate-exception.
 */
export const TakeRateExceptionFields = ({
  justification,
  approvedBy,
  approvedAt,
}: TakeRateExceptionFieldsProps) => (
  <div
    data-testid="take-rate-exception-fields"
    className="self-stretch flex flex-col justify-start items-start gap-4"
  >
    <Alert className="bg-amber-50 rounded-lg border border-yellow-500/50 w-full gap-1 inline-flex">
      <div className="flex gap-3 items-center pl-6">
        <div className="absolute top-4 left-4">
          <SirenIcon className="text-yellow-900" width={16} height={16} />
        </div>
        <div>
          <AlertTitle className="text-base font-medium text-yellow-900 mb-0">
            Exceção comercial
          </AlertTitle>
          <AlertDescription className="self-stretch text-yellow-900 text-sm font-normal leading-tight">
            A porcentagem de take informada está abaixo de 10%. Este lançamento
            é uma exceção comercial e precisa de justificativa, responsável e
            data da aprovação.
          </AlertDescription>
        </div>
      </div>
    </Alert>
    <div className="self-stretch flex flex-col justify-start items-start gap-2">
      <Label>Justificativa da exceção *</Label>
      <Textarea
        key={justification.key}
        name={justification.name}
        defaultValue={justification.value}
        placeholder="Descreva o motivo comercial para o take rate abaixo de 10%."
        className="h-24 bg-white border-[#d4d4d8] ring-inset"
      />
      {justification.errors && (
        <p className="text-red-500 text-sm self-stretch justify-start">
          {justification.errors}
        </p>
      )}
    </div>
    <div className="self-stretch inline-flex justify-start items-start gap-4">
      <div className="flex-1 flex flex-col justify-start items-start gap-2">
        <Label>Responsável pela aprovação *</Label>
        <div className="w-full">
          <Input
            label="Responsável pela aprovação"
            showlabel={false}
            key={approvedBy.key}
            name={approvedBy.name}
            defaultValue={approvedBy.value}
            placeholder="Digite o nome de quem aprovou a exceção."
            error={approvedBy.errors}
          />
        </div>
      </div>
      <div className="flex-1 flex flex-col justify-start items-start gap-2">
        <Label>Data da aprovação *</Label>
        <div className="w-full">
          <Input
            label="Data da aprovação"
            showlabel={false}
            type="date"
            key={approvedAt.key}
            name={approvedAt.name}
            defaultValue={approvedAt.value}
            error={approvedAt.errors}
          />
        </div>
      </div>
    </div>
  </div>
);
